
<div class="content-form">
    <webhook-form-input [mainformGroup]="form"  [field]="name" ></webhook-form-input>
    <div class="multiple-context">
        <!--div class="label-switch">
            <nz-switch [(ngModel)]="multipleContext" (ngModelChange)="changeContext($event)"></nz-switch> {{'workflow.multiple.context'|translateTA}}
        </div-->
        <button nz-button nzType="primary" (click)="openContextModal()" *ngIf="multipleContext">
            <nz-icon nzType="shop" />
            {{'context'|translateTA}}
        </button>
    </div>
    <nz-divider class="tight-divider"></nz-divider>
    <!--webhook-form-search [mainformGroup]="form"  [field]="codecompany" *ngIf="!multipleContext"></webhook-form-search-->
    <webhook-form-search [mainformGroup]="form"  [field]="codemktp" ></webhook-form-search>
    <webhook-form-search [mainformGroup]="form"  [field]="codemktpdest" ></webhook-form-search>
    <!--webhook-form-select [mainformGroup]="form"  [field]="environment" ></webhook-form-select-->
    <!--webhook-form-input [mainformGroup]="form"  [field]="schedule" *ngIf="!multipleContext" ></webhook-form-input-->
</div>    